module.exports = __webpack_public_path__ + "img/portfolio-6.1298b3aa.jpg";